import { ChevronRightIcon } from '@rsos/base-assets/icons';
import { Box, Text } from '@rsos/base-components';
import { ViewAllButton } from './SuggestedResponses.styles';

interface NoShownResponsesInterface {
  handleViewClick?: () => void;
}

const NoShownResponses = ({ handleViewClick }: NoShownResponsesInterface) => {
  return (
    <Box width="100%" horizontal justify="flex-end" alignItems="center">
      <ViewAllButton onClick={handleViewClick}>
        <Text mr="4px">View Preconfigured Messages</Text>
        <ChevronRightIcon
          viewboxHeight="18"
          viewboxWidth="18"
          width="12px"
          height="12px"
        />
      </ViewAllButton>
    </Box>
  );
};

export default NoShownResponses;
